/**
 * Shared UI copy for staff actions that email account sign-in / password-setup links.
 * Keeps student, coach, and manager lists and forms consistent.
 */
import i18n from '../i18n';

export const SIGN_IN_LINK = {
    get button() {
        return i18n.t('accountAccess.signInLink.button');
    },
    get buttonTitle() {
        return i18n.t('accountAccess.signInLink.buttonTitle');
    },
    get buttonTitleNoEmail() {
        return i18n.t('accountAccess.signInLink.buttonTitleNoEmail');
    },
    noEmailAlert: (role) => i18n.t('accountAccess.signInLink.noEmailAlert', { role }),
    listConfirm: (role) => i18n.t('accountAccess.signInLink.listConfirm', { role }),
    editConfirm: (role) => i18n.t('accountAccess.signInLink.editConfirm', { role }),
    get success() {
        return i18n.t('accountAccess.signInLink.success');
    },
    get failure() {
        return i18n.t('accountAccess.signInLink.failure');
    },
    get createCheckbox() {
        return i18n.t('accountAccess.signInLink.createCheckbox');
    },
    get createNote() {
        return i18n.t('accountAccess.signInLink.createNote');
    },
    get bulkImportOption() {
        return i18n.t('accountAccess.signInLink.bulkImportOption');
    },
};

/** Guardian invites are a separate flow (parent/guardian access, not staff login). */
export const GUARDIAN_INVITE = {
    get inviteButton() {
        return i18n.t('guardiansSection.inviteButton');
    },
    get resendButton() {
        return i18n.t('guardiansSection.resendButton');
    },
    get sending() {
        return i18n.t('guardiansSection.sending');
    },
    get inviteFailure() {
        return i18n.t('guardiansSection.inviteFailure');
    },
    get resendFailure() {
        return i18n.t('guardiansSection.resendFailure');
    },
    get invalidLink() {
        return i18n.t('guardianPublic.invalidLink');
    },
};

export const PASSWORD_RESET = {
    get pageSubtitle() {
        return i18n.t('accountAccess.passwordReset.pageSubtitle');
    },
    get successMessage() {
        return i18n.t('accountAccess.passwordReset.successMessage');
    },
    get submitButton() {
        return i18n.t('accountAccess.passwordReset.submitButton');
    },
    get publicHelp() {
        return i18n.t('accountAccess.passwordReset.publicHelp');
    },
};
